module.exports = __webpack_public_path__ + "static/media/fullscreen-square.48728054.svg";